module.exports = __webpack_public_path__ + "img/river.161db786.svg";